import { render, staticRenderFns } from "./InvalidFeedback.vue?vue&type=template&id=0634f654&"
import script from "./InvalidFeedback.vue?vue&type=script&lang=js&"
export * from "./InvalidFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports